//* External
import PropTypes from 'prop-types';

//* App Custom
import { CSS_COLORS, ICONS, ICON_SIZES } from '@constantsApp/index';

const CustomIcon = ({ name, size = 'S', color = 'green-dark', className, title }) => {
  const IconComponent = ICONS[name] || ICONS['circle'];
  return (
    <div title={title}>
      <IconComponent
        className={className}
        size={ICON_SIZES[size]}
        color={CSS_COLORS[color]}
      />
    </div>
  );
};

CustomIcon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOf(['XS', 'S', 'MD', 'LG', 'XL']),
  color: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string
};

export default CustomIcon;
